export const INCREMENT_PRODUCT = "INCREMENT_PRODUCT";
export const DECREMENT_PRODUCT = "DECREMENT_PRODUCT";
export const SET_PRODUCT = "SET_PRODUCT";
export const SET_NEW_PRODUCT_QUANTITIES = "SET_NEW_PRODUCT_QUANTITIES";
export const CLEAR_SELECTED_PRODUCTS = "CLEAR_SELECTED_PRODUCTS";

export const SET_PRODUCT_CONFIG = "SET_PRODUCT_CONFIG";

export function incrementProduct(id) {
    return (dispatch, getState) => {
        let state = getState();
        let product = state.products.products[id];
        let quantity = state.productPicker.productsQuantities[id];

        if(quantity === +product.transaction_limit) {
            return;
        }

        dispatch({type: INCREMENT_PRODUCT, id});
    }
}

export function setProductConfig(configuration) {
    return {type: SET_PRODUCT_CONFIG, configuration};
}

export function decrementProduct(id) {
    return {type: DECREMENT_PRODUCT, id};
}

export function setProduct(id, value, configId = null) {
    return {type: SET_PRODUCT, id, value, configId};
}

export function setProductQuantities(quantities) {
    return {type: SET_NEW_PRODUCT_QUANTITIES, quantities};
}

export function clearSelectedProducts() {
    return {type: CLEAR_SELECTED_PRODUCTS};
}
